import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { isNullEmpty } from "../../../utils/validation";
import { getUnitPrice } from "../../../http/api/MasterAPI";

const UnitPriceSelect = ({ value, error, onChangeValue}) => {
  const [listUnitPriceSelect, setListUnitPriceSelect] = useState([]);
 

  async function getListUnitPriceSelect() {
    try {
      const response = await getUnitPrice();//単価
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          unitPriceCd: element.varCd,
          unitPriceName: element.varValue1,
        }))
        .filter(
          (x) => x.unitPriceName && x.unitPriceName.trim() !== ""
        );
      setListUnitPriceSelect(result);
    } catch (error) {
      console.error("Failed to fetch shop info:", error);
    }
  }

  useEffect(() => {
    getListUnitPriceSelect();
  }, []);

 

  return (
    <FormControl>
      <Select
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        sx={{ width: 200 }}
        error={!isNullEmpty(error)}
        //onFocus={ () => validate.handleTouch("unitPriceCd")}
      >
   
        {listUnitPriceSelect.map((item) => (
          <MenuItem
            key={"unitPrice"+item.unitPriceCd}
            value={item.unitPriceCd}
          >
            {item.unitPriceName}
          </MenuItem>

        ))}
      </Select>
      {!isNullEmpty(error) && (
        <FormHelperText sx={{color:"#d32f2f",marginLeft: 0}}>{error}</FormHelperText>
      )} 
     </FormControl>
    
  );
};

export default UnitPriceSelect;
